<div class="row">
  <div class="col">
    <label class="mb-2 d-block">{{ field.label }}</label>

    <mat-radio-group [formControl]="control" [required]="field.isRequired">
      <mat-radio-button
        *ngFor="let option of field.options"
        [value]="option.value"
        class="d-block mb-1"
      >
        {{ option.value }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-error *ngIf="control.hasError('required') && control.touched">
      {{ field.label }} is required
    </mat-error>
  </div>
</div>
